import { render } from "./PostComposer.vue?vue&type=template&id=b5a40962&scoped=true"
import script from "./PostComposer.vue?vue&type=script&lang=js"
export * from "./PostComposer.vue?vue&type=script&lang=js"

import "./PostComposer.vue?vue&type=style&index=0&id=b5a40962&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5a40962"]])

export default __exports__